import $ from 'jquery';

$(function() {
    $('.share-like').on('click', function() {
        const data = {
            action: 'add_clap',
            id: $(this).attr('data-id'),
        };
        /* eslint-disable-next-line camelcase */
        $.post(ajax_object.ajax_url, data, function(response) {
            $('.like-number').text(response);
            $('.share-like').prop('disabled', true);
        }).fail(function (error) {
            /* eslint-disable-next-line no-console */
            console.warn('Une erreur s\'est produite', error);
        });
    });
});
